import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "23",
      height: "23",
      x: ".5",
      y: ".5",
      stroke: "#747E8E",
      rx: "11.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#747E8E",
      "fill-rule": "evenodd",
      d: "M12.003 7.883c.387 0 .701-.31.701-.692a.696.696 0 0 0-.7-.691.696.696 0 0 0-.702.691c0 .382.314.692.701.692M10 9.803h2.353a.5.5 0 0 1 .5.5v5.032h2.104v1H9.75v-1h2.103v-4.532H10z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }